import { createElement as $$createElement, setStyle as $$setStyle, setDataset as $$setDataset, setEvent as $$setEvent, delegateEvent as $$delegateEvent, setHTMLProp as $$setHTMLProp, setHTMLAttr as $$setHTMLAttr, setHTMLProps as $$setHTMLProps, setHTMLAttrs as $$setHTMLAttrs, createTextNode as $$createTextNode, updateText as $$updateText, insertNode as $$insertNode, ForNode as $$ForNode, CondNode as $$CondNode, ExpNode as $$ExpNode, EnvNode as $$EnvNode, TryNode as $$TryNode, SnippetNode as $$SnippetNode, PropView as $$PropView, render as $$render } from "@dlightjs/dlight";
import { DLightViewProp, Pretty, Typed, View, required, CSSProperties } from "@dlightjs/dlight";
import { injectFuncToInitNodes } from "../Injection/utils";
interface HStackProps {
  spacing?: number;
  alignment?: "top" | "bottom" | "center";
  width?: string;
  height?: string;
  style?: CSSProperties;
  class?: string;
}
class HStack extends View implements HStackProps {
  constructor() {
    super();
    this.setStyles = this.setStyles.bind(this);
    this.didMount = this.didMount.bind(this);
  }
  $p$spacing;
  spacing = 0;
  $$spacing = 1;
  $p$alignment;
  alignment: HStackProps["alignment"] = "top";
  $$alignment = 2;
  $s$alignment = ["margin"];
  $p$width;
  width = "100%";
  $$width = 4;
  $p$height;
  height = "max-content";
  $$height = 8;
  $p$style;
  style?: HStackProps["style"] = {};
  $$style = 16;
  $p$class;
  class?: HStackProps["class"];
  $$class = 32;
  get children() {
    return this._$children;
  }
  margin;
  get $f$margin() {
    if (this._$cache("margin", [this.alignment])) {
      return this.margin;
    }
    return {
      top: "0 0 auto 0",
      bottom: "auto 0 0 0",
      center: "auto 0"
    }[this.alignment!] ?? "0 0 auto 0";
  }
  nodes: any[] = [];
  setStyles(nodes: any) {
    View.loopShallowEls(nodes, (el: HTMLElement) => {
      el.style.flexShrink = "0";
      el.style.margin = this.margin;
    });
  }
  didMount() {
    this.setStyles(this.nodes);
    injectFuncToInitNodes(this.nodes, this.setStyles);
  }
  Body() {
    let $node0, $node1;
    this._$update = $changed => {
      if ($changed & 29) {
        $node0 && $$setStyle($node0, {
          ...this.style,
          height: this.height,
          width: this.width,
          columnGap: `${this.spacing}px`,
          display: "flex",
          flexDirection: "row"
        });
      }
      if ($changed & 32) {
        $node0 && $$setHTMLProp($node0, "className", () => this.class, [this.class]);
      }
    };
    $node0 = $$createElement("div");
    $$setHTMLProp($node0, "className", () => this.class, [this.class]);
    $$setStyle($node0, {
      ...this.style,
      height: this.height,
      width: this.width,
      columnGap: `${this.spacing}px`,
      display: "flex",
      flexDirection: "row"
    });
    $node1 = new $$ExpNode(this.children, []);
    View.addDidMount($node1, (node: any) => {
      this.nodes = node._$nodes;
    });
    $$insertNode($node0, $node1, 0);
    $node0._$nodes = [$node1];
    return [$node0];
  }
}
export default ((HStack as Pretty) as Typed<HStackProps>);